<div class="container pt-5 my-5">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Designation</th>
        <th scope="col">Member Name</th>
        <th scope="col">Contact Number</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th scope="row">1</th>
        <td>Sarapanch</td>
        <td>Tapas Kumar Das</td>
        <td>&#64;mdo</td>
      </tr>
      <tr>
        <th scope="row">2</th>
        <td>PEO</td>
        <td>Prasanna Kumar Mohanty</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">3</th>
        <td>Jogan Sahayak</td>
        <td>Sanjib Kumar Sahu</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">4</th>
        <td>Name of ADEO</td>
        <td>Namitarani Ghosh</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">5</th>
        <td>Self Employment Mechanisim</td>
        <td>Ajit Kumar Naik, Rajendra Naik, Hadibandhu Behera</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">6</th>
        <td>Panchayat Samiti Members</td>
        <td>Jharana Patra</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">7</th>
        <td>Naik Sarapanch</td>
        <td>Hashamani Sahu</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">8</th>
        <td>Ward Member</td>
        <td>Saraswati Behera</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">9</th>
        <td>Ward Member</td>
        <td>Kanhu Charan Murmu</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">10</th>
        <td>Ward Member</td>
        <td>Fulamani Murmu</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">11</th>
        <td>Ward Member</td>
        <td>Maina Murmu</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">12</th>
        <td>Ward Member</td>
        <td>Sukanti Patra</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">13</th>
        <td>Ward Member</td>
        <td>Muniram Hembram</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">14</th>
        <td>Ward Member</td>
        <td>Basanta Tudu</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">15</th>
        <td>Ward Member</td>
        <td>Mahi Soren</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">16</th>
        <td>Ward Member</td>
        <td>Niranjan Mal</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">17</th>
        <td>Ward Member</td>
        <td>Santosh Kumar Behera</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">18</th>
        <td>Ward Member</td>
        <td>Surubali Soren</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">19</th>
        <td>Ward Member</td>
        <td>Sushanta Pratihari</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">20</th>
        <td>Ward Member</td>
        <td>Sunita Naik</td>
        <td>&#64;fat</td>
      </tr>
      <tr>
        <th scope="row">21</th>
        <td>Ward Member</td>
        <td>Kabita Behera</td>
        <td>&#64;fat</td>
      </tr>
    </tbody>
  </table>
</div>
